/**
 * @file Shared loading / error / empty states so every page handles async
 * uniformly.
 */

/** @param {{ label?: string }} props */
export function LoadingState({ label = 'Loading…' }) {
  return (
    <div className="scrw-state scrw-state--loading" role="status" aria-live="polite">
      <span className="scrw-spinner" aria-hidden="true" />
      <p>{label}</p>
    </div>
  );
}

/**
 * @param {{ error: Error|null, onRetry?: () => void, label?: string }} props
 */
export function ErrorState({ error, onRetry, label = 'Something went wrong.' }) {
  return (
    <div className="scrw-state scrw-state--error" role="alert">
      <p className="scrw-state__title">{label}</p>
      {error && error.message ? (
        <p className="scrw-state__detail">{error.message}</p>
      ) : null}
      {onRetry ? (
        <button type="button" className="scrw-btn scrw-btn--ghost" onClick={onRetry}>
          Try again
        </button>
      ) : null}
    </div>
  );
}

/** @param {{ label?: string }} props */
export function EmptyState({ label = 'Nothing here yet.' }) {
  return (
    <div className="scrw-state scrw-state--empty">
      <p>{label}</p>
    </div>
  );
}
